module.exports = __webpack_public_path__ + "static/portfolio_gallery_20-77e035249f3215418c71b947ce43f8eb.jpg";